import type { SelectedSnapshot } from '../../../utils/overdueInvoiceAging'
import { parseConcatenatedJson } from '../../../utils/overdueInvoiceAging'

export function parseClientsFromSnapshot(row: SelectedSnapshot | null): Record<string, unknown>[] {
	if (!row) return []
	const md = row.monthly_client_details
	if (Array.isArray(md) && md.length > 0) {
		return md as Record<string, unknown>[]
	}
	const raw = row.clients_with_overdue_details
	if (typeof raw === 'string' && raw.trim()) {
		try {
			const parsed = JSON.parse(raw) as unknown
			return Array.isArray(parsed) ? (parsed as Record<string, unknown>[]) : []
		} catch {
			return parseConcatenatedJson(raw, 'clients')
		}
	}
	return []
}

export function topOverdueInvoicesFromSnapshot(
	row: SelectedSnapshot | null
): Record<string, unknown>[] {
	if (!row) return []
	const raw = row.top_overdue_invoices_detail as unknown
	if (Array.isArray(raw)) return raw as Record<string, unknown>[]
	if (typeof raw === 'string' && raw.trim()) {
		return parseConcatenatedJson(raw, 'top_invoices')
	}
	return []
}
